import { CategoryDto } from "../../../types/category";

export const REORDER_CATEGORIES = "REORDER_CATEGORIES";
export const REORDER_CATEGORIES_SUCCESS = "REORDER_CATEGORIES_SUCCESS";
export const REORDER_CATEGORIES_ERROR = "REORDER_CATEGORIES_ERROR";

export interface ReorderCategories {
  type: typeof REORDER_CATEGORIES;
  payload: CategoryDto[];
}

export interface ReorderCategoriesSuccess {
  type: typeof REORDER_CATEGORIES_SUCCESS;
  payload: CategoryDto[] | null;
}

export interface ReorderCategoriesError {
  type: typeof REORDER_CATEGORIES_ERROR;
  payload: boolean | string;
}

export interface State {
  data: CategoryDto[] | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions = ReorderCategories | ReorderCategoriesSuccess | ReorderCategoriesError;
